import React from 'react'
import { FormattedMessage } from 'react-intl';
import './SSO-CMS.css'


class SSOTerms extends React.Component {
    state = {
        agreedTerms: false,
        clickedLink: false,
    };

    componentDidMount() {
    }

    toggleAgreeTerms = (event) => {
        this.setState({agreedTerms: event.target.checked})
    }

    clickedTermsLink = (event) => {
        if(this.state.clickedLink)
            return;
        this.setState({clickedLink: true})
    }

    render() {
        return(
            <div className='card' >
                <div className='header text-center'>
                    <h2><FormattedMessage id="TERMS_AND_CONDITIONS" /></h2>                    
                </div>
                <div className='mt-2 text-center'>
                    <a href='https://www.screenbeam.com/about/terms-of-use/' target='_blank' onClick={(e) => this.clickedTermsLink(e)}>https://www.screenbeam.com/about/terms-of-use/</a>
                </div>
                <div className='mt-2 mb-2 text-center'>
                    <input onChange={(e)=>this.toggleAgreeTerms(e)} className="form-check-input" type="checkbox" value="" id="agreeTerms" checked={this.state.agreedTerms}/>
                    <label className="form-check-label ms-2 fw-bolder" htmlFor="agreeTerms">
                        <FormattedMessage id="AGREE_TERMS_AND_CONDITIONS" defaultMessage="I agree to these terms and conditions" />
                    </label>                
               </div>
               <button type='button' className='btn btn-primary' onClick={this.props.onSignUp} disabled={!(this.state.agreedTerms && this.state.clickedLink)}>
                    <FormattedMessage id="CONTINUE_BTN" />
               </button>
            </div>
        )
    }
}

export default SSOTerms;